import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Daemonizing node.js processes",
  "description": "",
  "published": "2011-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1864"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Napisat par stvari o lastnih poskusih demonizacije, potem opisat kok je forever kul.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      